import { useRouter } from 'next/router';

import clsx from 'clsx';

import useTranslation from '@/utils/hooks/translation/useTranslation';
// Hooks
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';
import useUserRole from '@/utils/hooks/user/useUserRole';

import useRouterQuery from '@/utils/hooks/utils/useRouterQuery';

import { getOauthUrl } from '@/lib/scheduler/getOauthUrl';
// Lib
import { FACEBOOK, LINKEDIN, THREADS, TWITTER, X } from '@/lib/socialProfile';

// Components
import Button from '@/components/base/Button';
import ModalBlockContent from '@/components/base/Modal/ModalBlockContent';
import { Trans } from '@/components/tools/translation';

const perms = {
    [FACEBOOK]: {
        admin: {
            title: 'modal_perms.facebook.admin.title',
            content: 'modal_perms.facebook.admin.content'
        },
        team_member: {
            title: 'modal_perms.facebook.team_member.title',
            content: 'modal_perms.facebook.team_member.content'
        }
    },
    [TWITTER]: {
        admin: {
            title: 'modal_perms.twitter.admin.title',
            content: 'modal_perms.twitter.admin.content'
        },
        team_member: {
            title: 'modal_perms.twitter.team_member.title',
            content: 'modal_perms.twitter.team_member.content'
        }
    },
    [X]: {
        admin: {
            title: 'modal_perms.twitter.admin.title',
            content: 'modal_perms.twitter.admin.content'
        },
        team_member: {
            title: 'modal_perms.twitter.team_member.title',
            content: 'modal_perms.twitter.team_member.content'
        }
    },
    [THREADS]: {
        admin: {
            title: 'modal_perms.threads.admin.title',
            content: 'modal_perms.threads.admin.content'
        },
        team_member: {
            title: 'modal_perms.threads.team_member.title',
            content: 'modal_perms.threads.team_member.content'
        }
    },
    [LINKEDIN]: {
        admin: {
            title: 'modal_perms.linkedin.admin.title',
            content: 'modal_perms.linkedin.admin.content'
        },
        team_member: {
            title: 'modal_perms.linkedin.team_member.title',
            content: 'modal_perms.linkedin.team_member.content'
        }
    }
};

const SchedulerPermissionModal = () => {
    const { isAdmin, isManager } = useUserRole();
    const isAdminOrManager = isAdmin || isManager;
    const userRole = isAdminOrManager ? 'admin' : 'team_member';
    const { activeSocialProfile } = useActiveSocialProfile();
    const socialProfileNetwork = activeSocialProfile?.social_network_type ?? FACEBOOK;
    const { t } = useTranslation('scheduler');
    const { deleteAllQueries } = useRouterQuery();
    const router = useRouter();
    const redirectUrl = deleteAllQueries(router.asPath);

    return (
        <ModalBlockContent>
            <ModalBlockContent.Body
                className={clsx({
                    'px-5 pt-12 sm:px-12': isAdminOrManager,
                    'px-5 py-12 sm:px-12': !isAdminOrManager
                })}>
                <ModalBlockContent.Title>
                    {t(perms[socialProfileNetwork][userRole].title)}
                </ModalBlockContent.Title>
                <ModalBlockContent.Content className="pt-8 text-center text-sm">
                    <Trans
                        i18nKey={`scheduler:${perms[socialProfileNetwork][userRole].content}`}
                        components={{
                            br: <br />,
                            span: <span className="italic text-icoGray-500" />
                        }}
                    />
                </ModalBlockContent.Content>
            </ModalBlockContent.Body>
            {isAdminOrManager ? (
                <ModalBlockContent.Footer className="my-8 flex justify-center space-x-6">
                    <Button as="a" href={getOauthUrl(socialProfileNetwork, redirectUrl)}>
                        {t('modal_perms.allow_perms_button')}
                    </Button>
                </ModalBlockContent.Footer>
            ) : null}
        </ModalBlockContent>
    );
};

export default SchedulerPermissionModal;
